var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { showNotice } from './showNotice';
import { enqueueCartAction } from './cartQueue';
export var addToCart = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var evt = _b.evt, button = _b.button, _c = _b.quantity, quantity = _c === void 0 ? 1 : _c, _d = _b.data, data = _d === void 0 ? {} : _d;
    return __generator(this, function (_e) {
        evt.preventDefault();
        return [2 /*return*/, enqueueCartAction(function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            button.classList.remove('added');
                            button.classList.add('loading');
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, axios.postForm("".concat(window.location.origin, "/wp-admin/admin-ajax.php"), {
                                    action: 'ajax_add_to_cart',
                                    product_id: button.getAttribute('data-product'),
                                    variation_id: button.getAttribute('data-variation'),
                                    quantity: quantity,
                                    data: data,
                                })];
                        case 2:
                            response = _a.sent();
                            if (response.data.success) {
                                showNotice();
                                button.classList.add('added');
                                document.body.dispatchEvent(new CustomEvent('updateMiniCart', {
                                    bubbles: true,
                                    detail: response.data.data,
                                }));
                            }
                            else {
                                // eslint-disable-next-line no-console
                                console.error('Failed to add product to cart:', response.data.data);
                            }
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _a.sent();
                            // eslint-disable-next-line no-console
                            console.error('Error adding product to cart:', error_1);
                            return [3 /*break*/, 5];
                        case 4:
                            button.classList.remove('loading');
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); })];
    });
}); };
